import type { Asset, AssetReservation, AssetStatus } from "@/domains/assets/api/types";
import { SEED_ASSETS, SEED_RESERVATIONS } from "@/domains/assets/mocks/assets";

let assets: Array<Asset> = SEED_ASSETS.map((a) => ({ ...a }));
const reservations: Array<AssetReservation> = SEED_RESERVATIONS.map((r) => ({ ...r }));

function delay<T>(value: T, ms = 220): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

export async function fetchAssets(): Promise<ReadonlyArray<Asset>> {
  return delay(assets);
}

export async function fetchAssetById(id: string): Promise<Asset | undefined> {
  return delay(assets.find((a) => a.id === id));
}

export async function fetchReservationsByAsset(
  assetId: string,
): Promise<ReadonlyArray<AssetReservation>> {
  return delay(reservations.filter((r) => r.assetId === assetId));
}

export async function fetchAllReservations(): Promise<ReadonlyArray<AssetReservation>> {
  return delay(reservations);
}

export async function updateAssetStatus(id: string, status: AssetStatus): Promise<Asset> {
  const idx = assets.findIndex((a) => a.id === id);
  if (idx === -1) throw new Error(`Asset niet gevonden: ${id}`);
  const updated: Asset = { ...assets[idx], status };
  assets = [...assets.slice(0, idx), updated, ...assets.slice(idx + 1)];
  return delay(updated, 150);
}

export async function fetchAvailableAssets(
  startDate: string,
  endDate: string,
): Promise<ReadonlyArray<Asset>> {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const available = assets.filter((a) => {
    if (a.status === "outOfService" || a.status === "maintenance") return false;
    const overlaps = reservations.some((r) => {
      if (r.assetId !== a.id) return false;
      const rStart = new Date(r.startDate);
      const rEnd = new Date(r.endDate);
      return rStart <= end && rEnd >= start;
    });
    return !overlaps;
  });
  return delay(available);
}
